import { createRequest } from "helpers/tools";

export type TestRunStatus =
    | "PENDING"
    | "QUEUED"
    | "PROCESSING"
    | "COMPLETED"
    | "FAILED"
    | "EXPIRED";

export interface StartTestByMappingPayload {
    mapping_id: number[];
    test_data?: Record<string, unknown>;
}

export interface TestRun {
    id: number;
    connection_id?: number;
    mapping_ids?: number[];
    business_id?: number;
    triggered_by_user_id?: number | null;
    platform_code?: string;
    external_lead_ids?: string[] | null;
    test_data?: Record<string, unknown> | null;
    incoming_request?: Record<string, unknown> | null;
    processed_data?: Record<string, unknown> | null;
    outgoing_request?: Record<string, unknown> | null;
    outgoing_response?: Record<string, unknown> | null;
    status?: TestRunStatus;
    error_message?: string | null;
    expires_at?: string | null;
    processed_at?: string | null;
    sent_at?: string | null;
    created_at?: string;
    updated_at?: string;
}

interface CreateRequestResult<T> {
    status: boolean;
    message?: string;
    data?: T;
}

/**
 * Start a connection test run by source-destination mapping IDs (wizard flow),
 * used when no connection_id exists yet. For Facebook/TikTok platforms test_data
 * must NOT be sent; for LinkedIn/Custom API platforms test_data is required.
 */
export const startTestByMapping = async (
    payload: StartTestByMappingPayload,
): Promise<CreateRequestResult<TestRun>> => {
    return await createRequest({
        suffix: "lead/connection/test-by-mapping",
        method: "post",
        payload,
        handleError: true,
    });
};

/**
 * Poll a single test run by its id to read the latest status/result.
 */
export const getTestRun = async (
    id: number,
): Promise<CreateRequestResult<TestRun>> => {
    return await createRequest({
        suffix: `lead/connection/test-run/${id}`,
        method: "get",
        payload: undefined,
        handleError: false,
    });
};
